import { practiceAreas } from '@/data/practiceAreas';
import PracticeAreaTemplate from '@/components/PracticeAreaTemplate';

export default function ProbatePage() {
  return <PracticeAreaTemplate practiceArea={practiceAreas.probate} />;
}
